import { FileMetadataDetailsResponse } from "@dune/types";
import { Loader } from "@dune/ui";
import { getErrorMessage } from "@dune/vars";

type DebugMetadataDisplayProps = {
	isLoading: boolean;
	isError: boolean;
	error: unknown;
	fileMetadataDetails?: FileMetadataDetailsResponse;
};

export const DebugMetadataDisplay = ({
	isLoading,
	isError,
	error,
	fileMetadataDetails,
}: DebugMetadataDisplayProps) => {
	if (isLoading) {
		return (
			<div className="flex justify-center items-center">
				<Loader className="w-10 h-10 text-[#0096b5]" />
			</div>
		);
	}
	if (isError) {
		return <div className="text-red-500">{getErrorMessage(error)}</div>;
	}
	if (!fileMetadataDetails) {
		return null;
	}
	if (!fileMetadataDetails.brutMetadata) {
		return null;
	}
	return (
		<div className="flex flex-col gap-2 p-2">
			{fileMetadataDetails.hasEncounteredErrorDuringConsumption ? (
				<div className="flex flex-col gap-2">
					<div className="flex items-center gap-2 text-red-600 font-semibold">
						<span className="w-3 h-3 rounded-full bg-red-500 inline-block" />
						Erreur lors de la consommation des métadonnées
					</div>
					{fileMetadataDetails.errorMessage && (
						<div className="text-xs text-red-500">
							{fileMetadataDetails.errorMessage}
						</div>
					)}
				</div>
			) : fileMetadataDetails.hasMetadataBeenConsumedByApplication ? (
				<div className="flex items-center gap-2 text-green-600 font-semibold">
					<span className="w-3 h-3 rounded-full bg-green-500 inline-block" />
					Métadonnées consommées par l'application
				</div>
			) : (
				<div className="flex items-center gap-2 text-yellow-600 font-semibold">
					<span className="w-3 h-3 rounded-full bg-yellow-400 inline-block" />
					Métadonnées non encore consommées
				</div>
			)}

			<div className="text-sm text-gray-500 font-semibold mb-2">
				Type de document :{" "}
				<span className="font-normal">
					{fileMetadataDetails.documentTypeIdentified}
				</span>
			</div>
			<div className="text-sm text-gray-500 font-semibold mb-2">
				Type :{" "}
				<span className="font-normal">
					{fileMetadataDetails.issuerTypeIdentified}
				</span>
			</div>
			{fileMetadataDetails.brutMetadata && (
				<div className="text-sm text-gray-500">
					<div className="font-semibold mb-2">Métadonnées initiales brutes</div>
					<pre className="whitespace-pre-wrap break-all bg-gray-100 rounded p-2 max-h-64 overflow-auto text-xs font-mono">
						<code>
							{JSON.stringify(fileMetadataDetails.brutMetadata, null, 2)}
						</code>
					</pre>
				</div>
			)}
		</div>
	);
};
